export default function ArrowIcon() {
  return (
    <span className="text-[2.2rem] font-light leading-none text-[#1d1d1d] md:text-[2.6rem]">
      →
    </span>
  );
}